module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-menu-thumbnails-400x400-fbca9bcd0a1b49a7c6c6560a2118d56d.jpg";